<template>
    <v-card class="rounded mb-6">
        <div class="px-4 pt-4 pb-2">
            <p class="text-medium-grey font-bold text-base uppercase mb-3">Cereri configurator vs proforme - RO</p>
        </div>
        <v-data-table :headers="headers" :items="leadsProformeAggregate" item-key="judet" :loading="loading"
            :items-per-page="14">
        </v-data-table>
    </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
    name: "ConfiguratorLeadsProforme",
    props: {
        fromDate: { type: String, required: true },
        toDate: { type: String, required: true },
    },
    data() {
        return {
            headers: [
                { text: 'Judet', align: 'start', sortable: true, value: 'judet', width: '40%' },
                { text: 'Nr. cereri', align: 'center', sortable: true, value: 'cereri', width: '20%' },
                { text: 'Proforme emise', align: 'center', sortable: true, value: 'proforme', width: '20%' },
            ]
        }
    },
    computed: {
        ...mapState('reports', {
            loading: state => state.loadingLeadsProformeAggregate,
            leadsProformeAggregate: state => state.configuratorLeadsProformeAggregate,
        }),
    },
    watch: {
        fromDate() { this.fetch(); },
        toDate() { this.fetch(); },
    },
    methods: {
        ...mapActions('reports', ['fetchConfiguratorLeadsProformeAggregate']),
        fetch() {
            this.fetchConfiguratorLeadsProformeAggregate({ fromDate: this.fromDate, toDate: this.toDate });
        },
    },
    mounted() {
        this.fetch();
    }
}
</script>
